/*!
 * High Wire Distilling - Big Thirst Storefront Loader
 *
 * Install this stable file once on the WordPress site. It fetches the config
 * with a fresh query string because Shopify Files are long cached.
 */

(function () {
  'use strict';

  if (window.__BT_HIGH_WIRE_LOADER_LOADED) return;
  window.__BT_HIGH_WIRE_LOADER_LOADED = true;

  var DEFAULT_CONFIG_SRC = 'https://checkout-6.bigthirst.com/cdn/shop/files/high-wire-config.js';
  var configSrc = window.__BT_HIGH_WIRE_CONFIG_SRC || DEFAULT_CONFIG_SRC;
  var configVersion = window.__BT_HIGH_WIRE_CONFIG_VERSION || String(Date.now());
  var separator = configSrc.indexOf('?') === -1 ? '?' : '&';
  var head = document.head || document.documentElement;
  var script = document.createElement('script');

  script.src = configSrc + separator + 'v=' + encodeURIComponent(configVersion);
  script.async = false;
  script.setAttribute('data-bt-high-wire-config', 'true');
  head.appendChild(script);
})();
